import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center display-2 my-8 font-weight-bold"
}
const _hoisted_2 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createBlock(_component_v_alert, { color: "rgba(0,0,0,0)" }, {
    default: _withCtx(() => [
      false
        ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "Interests"))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(_component_v_chip, {
            label: "",
            "x-large": "",
            class: "mr-2 mb-2"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("h3", { class: "font-weight-regular" }, " Sports ", -1)
            ])),
            _: 1,
            __: [0]
          }),
          _createVNode(_component_v_chip, {
            label: "",
            "x-large": "",
            class: "mr-2 mb-2"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("h3", { class: "font-weight-regular" }, " Music ", -1)
            ])),
            _: 1,
            __: [1]
          }),
          _createVNode(_component_v_chip, {
            label: "",
            "x-large": "",
            class: "mr-2 mb-2"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("h3", { class: "font-weight-regular" }, " Psychology ", -1)
            ])),
            _: 1,
            __: [2]
          }),
          _createVNode(_component_v_chip, {
            label: "",
            "x-large": "",
            class: "mr-2 mb-2"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("h3", { class: "font-weight-regular" }, " Education ", -1)
            ])),
            _: 1,
            __: [3]
          }),
          _createVNode(_component_v_chip, {
            label: "",
            "x-large": "",
            class: "mr-2 mb-2"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createElementVNode("h3", { class: "font-weight-regular" }, " Blockchain ", -1)
            ])),
            _: 1,
            __: [4]
          }),
          _createVNode(_component_v_chip, {
            label: "",
            "x-large": "",
            class: "mr-2 mb-2"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createElementVNode("h3", { class: "font-weight-regular" }, " Artificial Intelligence ", -1)
            ])),
            _: 1,
            __: [5]
          })
        ])
      ])
    ]),
    _: 1
  }))
}